export enum LocalStorageEnum {
  TOKEN = 'token',
  LANGUAGE = 'language',
  USER_AUTH = 'userAuth',
  AUTH_LOGIN_PAGE = 'authLoginPage',
  SELECTED_LANG = 'selectedLang',
  COUNTRY = 'country'
}
